import { createSlice } from "@reduxjs/toolkit";
import { dateTFormat } from "../utility/Utility";

export interface GetOrderListParam {
    startDate: string;
    orderStatus: string;
    restaurentId: string;
    rowsPerPage: number;
    ordreTotalPrice: number;
    orderSearchDate: string;
    orderSearchRowsPerPage: number;
    orderCreatedBy: string;
    cartName: string;
}

const initialState = {
    selectedOrder: null,
    orderStatus: "All",
    orderDate: dateTFormat(new Date()),
    orderEndDate: dateTFormat(new Date()),
    rowsPerPage: 10,
    ordreTotalPrice: 0,
    orderSearchDate: dateTFormat(new Date()),
    orderSearchRowsPerPage: 10,
    orderCreatedBy: "All",
    cartName: "",
    agentSourceFilter: {
        value: "all",
        label: "All",
        type: "all",
    },
};

export const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        hadaleSelectedOrder: (state, action) => {
            state.selectedOrder = action.payload;
        },
        setSelectedOrderCreatedBy: (state, action) => {
            state.orderCreatedBy = action.payload;
        },
        clearSelectedOrderCreatedBy: (state) => {
            state.orderCreatedBy = "";
        },
        setSelectedCartName: (state, action) => {
            state.cartName = action.payload;
        },
        clearSelectedCartName: (state) => {
            state.cartName = "";
        },
        setSelectedAgentSourceFilter: (state, action) => {
            state.agentSourceFilter = action.payload;
        },
        clearSelectedAgentSourceFilter: (state) => {
            state.agentSourceFilter = {
                value: "all",
                label: "All",
                type: "all",
            };
        },
        setSelectedOrderType: (state, action) => {
            state.orderStatus = action.payload;
        },
        clearSelectedOrderType: (state) => {
            state.orderStatus = "All";
        },
        setSelectedOrderDate: (state, action) => {
            state.orderDate = action.payload;
        },
        setSelectedOrderEndDate: (state, action) => {
            state.orderEndDate = action.payload;
        },
        clearSelectedOrderDate: (state) => {
            state.orderDate = dateTFormat(new Date());
        },
        clearSelectedOrderEndDate: (state) => {
            state.orderEndDate = dateTFormat(new Date());
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        clearRowsPerPage(state) {
            state.rowsPerPage = 10;
        },
        handaleOrdreTotalPrice(state, action) {
            state.ordreTotalPrice = action.payload;
        },
        setSearchSelectedOrderDate: (state, action) => {
            state.orderSearchDate = action.payload;
        },
        clearSearchSelectedOrderDate: (state) => {
            state.orderSearchDate = dateTFormat(new Date());
        },
        setSearchRowsPerPage(state, action) {
            state.orderSearchRowsPerPage = action.payload;
        },
        clearSearchRowsPerPage(state) {
            state.orderSearchRowsPerPage = 10;
        },
    },
});

export const {
    hadaleSelectedOrder,
    setSelectedOrderType,
    clearSelectedOrderType,
    setSelectedOrderDate,
    setSelectedOrderEndDate,
    clearSelectedOrderDate,
    clearSelectedOrderEndDate,
    setRowsPerPage,
    handaleOrdreTotalPrice,
    clearRowsPerPage,
    setSearchSelectedOrderDate,
    clearSearchSelectedOrderDate,
    setSearchRowsPerPage,
    clearSearchRowsPerPage,
    setSelectedOrderCreatedBy,
    clearSelectedOrderCreatedBy,
    setSelectedCartName,
    clearSelectedCartName,
    setSelectedAgentSourceFilter,
    clearSelectedAgentSourceFilter,
} = orderSlice.actions;

export default orderSlice.reducer;
